import React from 'react'

const LocalStorageContext = React.createContext()

LocalStorageContext.displayName = `LocalStorageContext`

export default LocalStorageContext
